<template>
    <div class="h-100" v-if="leaderDetail.trader">
        <app-follow v-if="followId" :followId="followId" @close="followId = ''"  :followName="followName"></app-follow>
        <div class="wt-leader-detail h-100 mt-3 ">
            <div class="container-fluid h-100">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="backBtn mb-3">
                            <a href="javascript:void(0)" class="d-inline-flex align-items-center white f-16" @click.prevent="$router.back()">
                                <span class="d-flex align-items-center justify-content-center mr-2">
                                    <img src="../../../../static/website/images/arrow-left.svg" >
                                </span>
                                {{$t('back')}}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="wt-leader-listDetail-main wt-scroll">
                    <div class="row">
                        <div class="col-lg-6">
                        <div class="wt-leader-detail-left secondatyBG p-4 radius-10 overflow-hidden">
                                <div class=" wt-leader-detail-header d-flex justify-content-between align-items-center">
                                    <div class="wt-leader-list-card-profile wt-scroll">
                                        <div class="d-flex align-items-center">
                                            <img class="wt-dashborad-leader-card-profileImg mr-2" :src="leaderImage" :alt="leader_id" height="60" style="border-radius: 50%;">
                                            <div>
                                                <span class="wt-leader-card-name f-14 w-auto">{{leaderDetail.trader.stats.profile.name || ''}}</span>
                                                <span class="wt-dashborad-chart-right-card-badge w-auto orange text-center pink d-flex align-items-center justify-content-center">
                                                    {{$t('risk')}} <span> {{ risk || '' }}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="py-2 wt-leader-list-card">
                                        <a href="javascript:void(0);" class="follow-btn btn white f-14 d-flex align-items-center justify-content-center px-3"
                                            :class="{'greenBG' : isFollowing(leaderDetail.trader.stats.providerId)}"
                                            @click.stop.prevent="followId = leaderDetail.trader.stats.providerId; followName = leaderDetail.trader.stats.profile.name;">
                                            {{isFollowing(leaderDetail.trader.stats.providerId)?'Following':'Follow Strategy'}}
                                        </a>
                                    </div>
                                </div>
                                <div class="wt-leader-detail-chart-sec ">
                                    <div class="wt-dashborad-chart-header mt-4">
                                        <div class="wt-dashborad-chart-header-total d-inline-flex align-items-center  mw-430@">
                                            <ul class="list-unstyled d-flex p-0">
                                                <li class="wt-dashborad-chart-header-total-box">
                                                    <span class="wt-dashborad-chart-header-total-label">{{$t('profit')}}:</span>
                                                    <span class="wt-dashborad-chart-header-total-value ms-1">
                                                        {{ (total_profit || 0) }}
                                                    </span>
                                                </li>
                                                <li class="wt-dashborad-chart-header-total-box">
                                                    <span class="wt-dashborad-chart-header-total-label">{{$t('copiers')}}: </span>
                                                    <span class="wt-dashborad-chart-header-total-value ms-1">{{leaderDetail.trader.stats.overallStats.followers || ''}} </span>
                                                </li>
                                                <li class="wt-dashborad-chart-header-total-box total-win">
                                                    <span class="wt-dashborad-chart-header-total-label">{{$t('win_rate')}}: </span>
                                                    <span class="wt-dashborad-chart-header-total-value ms-1">{{win_rate || 0}}% </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="my-4">
                                        <div class="wt-leader-detail-description wt-scroll ">
                                            <p class="f-14" v-if="Object.keys(leaderDetail).length && leaderDetail.trader.stats.profile"
                                                v-html="displayText"></p>
                                        </div>
                                        <a href="javascript:void(0)" class="isExpanded bold link" v-if="shouldShowToggle"  @click.prevent="toggleText">{{ isExpanded ? 'show less' : 'show more' }}</a>
                                    </div>
                                    <div class="wt-leader-detail-chart">
                                        <!-- <img src="../../../../static/website/images/dashboard-chart.png" class="w-100 chart-img" style="height: 290px;"> -->
                                        <ProfitChart
                                            :selectedTimefarme ="selectedTimefarme"
                                            :leader_detail=leader_detail
                                            v-if="Object.keys(leaderDetail).length"
                                        />
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
                                        <div class="">
                                            <span class="f-16">{{$t('live_profit')}} (%)</span>
                                        </div>
                                        <div class="wt-dashborad-chart-footer  ">
                                            <ul class="d-flex align-items-center p-0">
                                                <li v-for="item,key in timeFrameList" :key="item" @click.prevent.stop="updateSelectedTimeFrame(key)" :class="{'active':selectedTimefarme == key}">{{ item }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                        </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="wt-leader-detail-right secondatyBG p-4 radius-10 ">
                                <div class=" wt-leader-detail-header wt-leader-detail-right-box  d-flex flex-xl-nowrap flex-wrap justify-content-between align-items-center">
                                    <ul class="nav nav-tabs btn-tab border-0" >
                                        <li class="nav-item" role="presentation">
                                            <a href="javascript:void(0);"  @click="tab = 1;selected_tab = 'performance'" :class="{'active' : tab == 1}" class="btn justify-content-center mw-100 mx-auto text-uppercase px-3 radius-0">{{$t('advanced_stats')}}</a>
                                        </li>
                                        <li class="nav-item ml-xl-3 ml-2" role="presentation">
                                            <a href="javascript:void(0);"  @click="tab = 2" :class="{'active' : tab == 2}" class="btn justify-content-center mw-100 mx-auto text-uppercase px-3 radius-0">{{$t('portfolio')}}</a>
                                        </li>
                                    </ul>
                                    <div class="advanced-tab mt-2 mt-xl-0" v-if="tab == 1">
                                        <ul class="nav nav-tabs underline-tabs radius-5 px-4  border-0 bg">
                                            <li class="nav-item" role="presentation">
                                                <a href="javascript:void(0);"  @click="selected_tab = 'performance'" :class="{'active' : selected_tab == 'performance'}" class="btn justify-content-center mw-100 mx-auto py-2 ">{{$t('performance')}}</a>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <a href="javascript:void(0);"  @click="selected_tab = 'trading'" :class="{'active' : selected_tab == 'trading'}" class="btn justify-content-center mw-100 mx-auto py-2 ">{{$t('trading')}} </a>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <a href="javascript:void(0);"  @click="selected_tab = 'drawdown'" :class="{'active' : selected_tab == 'drawdown'}" class="btn justify-content-center mw-100 mx-auto py-2 ">{{$t('drawDown')}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="wt-leader-detail-chart-sec mt-3 wt-scroll" v-if="tab == 1">
                                    <div class="advanced-seat-tab-content text-center h-100">
                                        <div class="h-100" v-if="selected_tab == 'performance'">
                                            <performance-chart v-if="Object.keys(leaderDetail).length && selected_tab == 'performance'" key="performance"
                                                :date-drop="timeFrameList"
                                                :date-drop-selected="advancedSelectedTimefarme"
                                                @updateSelectedTimeFrame="updateAdvancedSelectedTimeFrame">
                                            </performance-chart>
                                        </div>
                                        <div class="h-100" v-if="selected_tab == 'trading'">
                                            <trading-chart v-if="Object.keys(leaderDetail).length && selected_tab == 'trading'" key="trading"
                                                :date-drop="timeFrameList"
                                                :date-drop-selected="advancedSelectedTimefarme"
                                                @updateSelectedTimeFrame="updateAdvancedSelectedTimeFrame">
                                            </trading-chart>
                                        </div>
                                        <div class="h-100" v-if="selected_tab == 'drawdown'">
                                            <drawdown-chart v-if="Object.keys(leaderDetail).length && selected_tab == 'drawdown'" key="drawdown"
                                                :date-drop="timeFrameList"
                                                :date-drop-selected="advancedSelectedTimefarme"
                                                @updateSelectedTimeFrame="updateAdvancedSelectedTimeFrame">
                                            </drawdown-chart>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="tab == 2" class="mt-3 table-tab"> 
                                    <LeadersTable></LeadersTable>                                
                                    <!-- <div class="wt-pagin">
                                        <ul class="pagination my-4 d-flex justify-content-end">
                                            <li class="page-item"><a class="page-link text-mute" href="javascript:void(0);">Prev</a></li>
                                            <li class="page-item active"><a class="page-link" href="javascript:void(0);">1</a></li>
                                            <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                                            <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                                            <li class="page-item"><a class="page-link" href="javascript:void(0);">Next</a></li>
                                        </ul>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import LeadersTable from './leader-detail/table'
    import { commonAllmixins } from "@/plugins/commonAll";
    import ProfitChart from "./leader-detail/Charts/Profit-Chart.vue";
    import performanceChart from './leader-detail/Charts/performance-chart.vue';
    import TradingChart from './leader-detail/Charts/trading-chart.vue'
    import drawdownChart from './leader-detail/Charts/drawdown-chart.vue'
    import AppFollow from './follow.vue';
    const product = process.env.product;
    export default{
        mixins: [commonAllmixins],
        data(){
            return{
                followId : '',
                followName : '',
                tab: 1,
                childTab: 1,
                timeFrameList:{
                    "1":"1D",
                    "3":"3D",
                    "7":"7D",
                    "30":"1M",
                    "90":"3M",
                    "180":"6m",
                    "365":"1Y",
                    // "540":"540",
                    "10000":"Overall",
                },
                selectedTimefarme: '10000',
                isExpanded: false,
                shortTextLength: 250,
                leader_id : null,
                selected_tab : 'performance',
                advancedSelectedTimefarme : '10000'
            }
        },
        components:{ LeadersTable,ProfitChart,performanceChart,TradingChart,drawdownChart, AppFollow },
        computed:{
            timeframeStats(){
                let timeaFrame = this.leaderDetail.trader.stats.timeframeStats;
                if(timeaFrame && timeaFrame[this.selectedTimefarme]){
                    return timeaFrame[this.selectedTimefarme]
                }else{
                    const entries = Object.entries(timeaFrame);
                    return entries[entries.length - 1][1];
                }
            },
            displayText() {
                if(this.leaderDetail  && this.leaderDetail.trader  &&  this.leaderDetail.trader.stats && this.leaderDetail.trader.stats.profile && this.leaderDetail.trader.stats.profile.strategyDesc){
                    if (this.isExpanded) {
                        return this.leaderDetail.trader.stats.profile.strategyDesc;
                    }
                    // Strip HTML tags and limit the text length
                    const plainText = this.leaderDetail.trader.stats.profile.strategyDesc.replace(/<[^>]+>/g, '');
                    const truncatedText = plainText.substring(0, this.shortTextLength);
                    return truncatedText + (plainText.length > this.shortTextLength ? '...' : '');
                }
                return '';
            },
            shouldShowToggle() {
                // Strip HTML tags to get plain text length
                if(this.leaderDetail && this.leaderDetail.trader && this.leaderDetail.trader.stats && this.leaderDetail.trader.stats.profile && this.leaderDetail.trader.stats.profile.strategyDesc){
                    const plainText = this.leaderDetail.trader.stats.profile.strategyDesc.replace(/<[^>]+>/g, '');
                    return plainText.length > this.shortTextLength;
                }
                return "";
            },
            leaderImage(){
                if(this.leaderDetail &&  this.leaderDetail.trader && this.leaderDetail.trader.stats &&  this.leaderDetail.trader.stats.profile){
                    return this.leaderDetail.trader.stats.profile.avatarURL;
                }

                if(Object.keys(this.leaderDetail).length && this.leaderDetail.trader.stats.profile.zuluAccountId){
                    return 'https://www.zulutrade.com/webservices/Image.ashx?type=user&size=XL&id='+this.leaderDetail.trader.stats.profile.zuluAccountId+'&ignore=false'
                }
            },
            win_rate(){
                if(Object.keys(this.leaderDetail).length && this.leaderDetail.trader.stats.timeframeStats){
                    let win_rate = this.leaderDetail.trader.stats.timeframeStats[this.selectedTimefarme].winTrades;
                    return this.notUndefined(win_rate) ? win_rate :'';
                }
            },

            risk(){
                if(Object.keys(this.leaderDetail).length && this.leaderDetail.trader.stats.timeframeStats){
                    return this.leaderDetail.trader.stats.timeframeStats[this.selectedTimefarme].timeFrameRisk;
                }
                return '';
            },
            total_trades(){
                if(Object.keys(this.leaderDetail).length && this.leaderDetail.trader.stats.timeframeStats){
                    return this.leaderDetail.trader.stats.timeframeStats[this.selectedTimefarme].trades;
                }
                return 0
            },
            total_profit(){
                if(Object.keys(this.leaderDetail).length && this.leaderDetail.trader.stats.timeframeStats){
                    let symbol = this.leaderDetail.trader.stats.profile.baseCurrencySymbol || '$'
                    return (symbol + this.numberFormating(this.leaderDetail.trader.stats.timeframeStats[this.selectedTimefarme].totalProfitMoney));
                }
                return '$0'
            }
        },
        methods:{
            updateSelectedTimeFrame(timeframe){
                this.selectedTimefarme = timeframe;
                this.$router.push({ path: this.$route.fullPath, query: { t: this.selectedTimefarme, m: 1 } });
            },
            updateAdvancedSelectedTimeFrame(timeframe){
                this.advancedSelectedTimefarme = timeframe;
            },
            entry(val,isLast){
                const entries = Object.entries(val);
                if(isLast){
                    return entries[entries.length - 1][1];
                }else{
                    return entries[0][1];
                }
            },
            toggleText() {
                this.isExpanded = !this.isExpanded;
            },
            notUndefined(value) {
                if(typeof value !== undefined){
                    return true;
                }
            },
        },
        created(){
            var params = new URL(location.href).searchParams;
            console.log('params------',params.get('t'))
            if( params.get('t') && Object.keys(this.timeFrameList).includes(params.get('t')) ){
                this.selectedTimefarme = params.get('t');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/copy-trade/leader-detail.vue